import getPageName from '@/tools/page-name'
import { getCurrentUser } from '@/tools/session/get-current-user'
import { translateObjectKeys } from '@/tools/object'
import { toSnakeCase } from '@/tools/string'
import generateUuid from '@/tools/generate-uuid'

window.dataLayer = window.dataLayer || []

const loadUserData = async () => {
  const [staleUser, promisedRevalidatedUser] = await getCurrentUser()

  let user = staleUser

  window.gtag?.('set', { 'view_id': generateUuid() })

  if (!user) {
    user = await promisedRevalidatedUser
  }

  window.gtag?.('set', { 'user_id': user.id })

  pushFunction(async function() {
    this.set('page_name', getPageName())
    this.set('user_id', user.id)

    // ensure network user as email is not available in stale user
    if (!user.email) {
      user = await promisedRevalidatedUser
    }

    this.set('user_email', user.email)

    // Purchase page has a special meaning for new_buyer and should
    // have priority over the default behavior.
    // https://github.com/enjoei/website/blob/master/app/views/shared/_data_layer_push_purchase.html.erb#L28
    if (this.get('new_buyer') === undefined) {
      this.set('new_buyer', user.isNewBuyer)
    }
  })
}

loadUserData()

export function pushFunction(fn) {
  window.dataLayer.push(fn)
}

export function pushEvent(name, variables = {}, options = {}) {
  pushVariables({
    event: name,
    ...variables
  }, options)
}

export function pushVariables(variables = {}, { shouldNormalizeSnakeCase = true } = {}) {
  if (shouldNormalizeSnakeCase) {
    variables = translateObjectKeys({ ...variables }, {}, toSnakeCase)
  }

  window.dataLayer.push({
    ...variables,
    _clear: true // https://github.com/google/data-layer-helper#recursively-merging-values
  })
}

// Por utilizar a lib gtag.js os parâmetros do evento devem ser do tipo number ou string
// Objetos serão parseados para string e no final será enviada a string '[object Object]
export function sendMetricEvent({ eventName, eventData = {}}) {
  const normalizeEventData = translateObjectKeys(eventData, {}, toSnakeCase)

  if (window && window.gtag) {
    window.gtag('event', eventName, normalizeEventData)
  }
}

export const pushInteraction = new EventQueue({
  eventName: 'interaction',
  normalizer: ({ context = 'interaction', type, content, highContentVariability = false } = {}) => {
    return translateObjectKeys({
      interactionContext: context,
      interactionType: type,
      interactionContent: content,
      interactionHighContentVariability: highContentVariability
    }, {}, toSnakeCase)
  }
})

function EventQueue({ eventName, eventTimeout = 2000, normalizer = data => data } = {}) {
  this.processing = false
  this.queue = []

  this.processNext = () => {
    const nextEvent = this.queue.shift()

    if (!nextEvent) { return }

    this.processing = true

    setTimeout(() => {
      pushEvent(eventName, {
        ...normalizer(nextEvent),
        eventCallback: () => {
          this.processing = false
          this.processNext()
        },
        eventTimeout
      }, {
        shouldNormalizeSnakeCase: false
      })
    })
  }

  return (eventData) => {
    this.queue.push(eventData)
    !this.processing && this.processNext()
  }
}
